<template>
  <div class="page-info">
    <div class="page-info-icon">
      <f-sprite-icon :icon-link="icon" />
    </div>
    <h2 class="title" v-html="title" v-if="title" />
    <p class="description" v-if="subtitle">
      {{ subtitle }}
    </p>
    <p class="description" v-if="$slots.default">
      <slot />
    </p>
  </div>
</template>

<script>
import IconInfo from '../../assets/images/info.multi.svg'

export default {
  name: 'page-info',

  props: {
    icon: {
      type: String,
      default: IconInfo.id,
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    }
  },
}
</script>

<style lang="scss">
.page-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 80px auto;

  .page-info-icon {
    & > svg {
      width: 64px;
      height: 64px;
    }
  }

  .title,
  .description {
    color: $black;
    text-align: center;
  }

  .title {
    margin: 16px 0 0;
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    font-family: Gilroy, sans-serif;
  }

  .description {
    max-width: 436px;
    padding: 8px;
    font-size: 14px;
    line-height: 20px;

    a {
      color: $blue;
    }
  }
}

@include breakpoint("desktop") {
  .page-info {
    margin: 120px auto;

    .title {
      font-size: 20px;
      line-height: 28px;
    }

    .description {
      font-size: 16px;
      line-height: 24px;
    }
  }
}
</style>
